var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
class Util {
  constructor() {
    __publicField(this, "_modulePath", ROUTES.featureExperiment.root.match.path);
    __publicField(this, "_modulePathname", ROUTES.featureExperiment.root.location.pathname);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        getURL: () => `${this.url}`
      },
      list: {
        path: () => `${this.path}`,
        getURL: () => `${this.url}`
      },
      view: {
        path: () => `${this.path}${ROUTES.featureExperiment.view.match.path}`,
        getURL: (payload) => {
          const { featureId, pivot } = payload;
          let append = !!pivot ? `/${pivot}` : "";
          return `${this.url}/${featureId}${append}`;
        }
      },
      create: {
        path: () => `${this.path}${ROUTES.featureExperiment.create.match.path}`,
        getURL: () => {
          return `${this.url}${ROUTES.featureExperiment.create.location.pathname}`;
        }
      },
      audienceStageCreate: {
        path: () => `${this.path}${ROUTES.featureExperiment.audienceStageCreate.match.path}`,
        getURL: (payload) => {
          const { featureId } = payload;
          return `${this.url}/${featureId}${ROUTES.featureExperiment.audienceStageCreate.location.pathname}`;
        }
      },
      audienceStageView: {
        path: () => `${this.path}${ROUTES.featureExperiment.audienceStageView.match.path}`,
        getURL: (payload) => {
          const { featureId, audienceStageId, pivot, view } = payload;
          let append = !!pivot ? `/${pivot}` : "";
          let appendView = !!view ? `/${view}` : "";
          return `${this.url}/${featureId}${ROUTES.featureExperiment.audienceStageView.location.pathname}/${audienceStageId}${append}${appendView}`;
        }
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const FeatureExperimentRouteUtils = new Util();
export {
  FeatureExperimentRouteUtils
};
//# sourceMappingURL=FeatureExperimentRoute.utils.js.map
